import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Modal from '@material-ui/core/Modal';

import getTeam from '../services/team/getTeam';
import getUser from '../services/user/getUser';
import getListings from '../services/listing/getAllListings';
import NewListingWizard from './NewListingWizard';
import NoContent from './NoContent';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    marginBottom: '30px',
  },
  table: {
    minWidth: 800,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  headercell: {
    cursor: 'pointer',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  formRoot: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  actionsDiv: {
    paddingTop: 30,
    display: 'flex',
    flexWrap: 'wrap',
  },
  btn: {
    marginTop: 20,
    marginRight: 30,
  },
  modal: {
    marginTop: 30,
    marginLeft: 'auto',
    marginRight: 'auto',
    overflow: 'auto',
    maxWidth: 960,
  },
});

const columnData = [
  {
    id: 'smsKeyword',
    sortKey: 'smsKeyword',
    numeric: false,
    disablePadding: true,
    label: 'SMS Keyword',
  },
  {
    id: 'agent',
    sortKey: 'agentName',
    numeric: false,
    disablePadding: true,
    label: 'Agent',
  },
  {
    id: 'listingAddress',
    sortKey: 'address',
    numeric: false,
    disablePadding: true,
    label: 'Address',
  },
  {
    id: 'leadsTotal',
    sortKey: 'leadCount',
    numeric: true,
    disablePadding: false,
    label: 'Leads Total',
  },
];

class ListingsHead extends Component {
  render() {
    const { onSelectAllClick, numSelected, rowCount, classes } = this.props;
    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell>
          {columnData.map(
            column => (
              <TableCell
                key={column.id}
                className={classes.headercell}
                numeric={column.numeric}
                padding="default" // {column.disablePadding ? 'none' : 'default'}
                onClick={this.props.sortData(column.sortKey)}
              >
                {column.label}
                <i
                  className={`fa ${
                    this.props.isAccending ? 'fa-arrow-up' : 'fa-arrow-down'
                  }`}
                  style={{ marginLeft: '5px' }}
                />
              </TableCell>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    );
  }
}

class Listings extends Component {
  state = {
    isLoading: true,
    listings: [],
    user: null,
    selected: [],
    listingAction: '',
    isAccending: true,
    isModalOpen: false,
    isEditing: false,
    error: null,
  };

  async componentDidMount() {
    try {
      let listings = [];
      let team = {};
      const user = await getUser();
      console.log('-----user------', user);

      if (user) {
        team = await getTeam(user.teamId);
        if (user.isResetSignRider) {
          this.props.history.push('/home/new-signrider', {
            ...user,
            ...team,
          });
          return;
        }
        listings = await getListings(user.teamId);
        this.setState({
          user,
          listings: listings.result,
          team: team.result,
          availableKeywords: this.getAvailableKeywords(
            team.result.keywordsAvailability
          ),
        });
      }
    } catch (e) {
      alert('An error occured');
    }
    this.setState({ isLoading: false });
  }

  getAvailableKeywords = availability => {
    const availableKeywords = [];
    for (let key in availability) {
      if (availability[key]) {
        availableKeywords.push(key);
      }
    }
    return availableKeywords;
  };
  isSelected = item => {
    const itemId = this.state.selected.findIndex(_item => {
      return _item.id === item.id;
    });
    return itemId !== -1 ? true : false;
  };

  handleClick = (event, listing) => {
    // when checking an item, put it in the selected
    // when unchecking an item, filter it out from the selected.
    const { selected } = this.state;
    const selectedIndex = selected.findIndex(item => {
      return item.id === listing.id;
    });
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat([], listing);
    } else {
      newSelected = selected.filter(item => {
        return item['id'] !== listing.id;
      });
    }
    this.setState({ selected: newSelected });
  };

  handleChangeActionSelection = event => {
    if (this.state.selected.length === 1 && event.target.value === 'Edit') {
      this.setState({
        isEditing: true,
        isModalOpen: true,
        listingAction: event.target.value,
      });
    } else {
      this.setState({ listingAction: event.target.value });
    }
  };

  handleCreateListing = listing => {
    //to make selection work properly for now, refactor this id thing in this component
    listing.id = listing.listingId;
    const listings = this.state.listings;
    const newListings = listings.concat([listing]);
    const availableKeywords = this.state.availableKeywords.filter(k => {
      return k !== listing.smsKeyword;
    });

    this.setState({
      listings: newListings,
      availableKeywords,
      isModalOpen: false,
      isEditing: false,
      listingAction: '',
      selected: [],
    });
  };

  handleUpdateListing = listing => {
    const newListings = this.state.listings.map(l => {
      if (l.listingId === listing.listingId) {
        //to make selection work properly for now, refactor this id thing in this component
        listing.id = listing.listingId;
        return listing;
      }
      return l;
    });
    this.setState({
      listings: newListings,
      isModalOpen: false,
      isEditing: false,
      listingAction: '',
      selected: [],
    });
  };

  handleDeleteListing = async () => {
    const user = await getUser();
    console.log('-----deleted------');

    if (user) {
      const team = await getTeam(user.teamId);
      const listings = await getListings(user.teamId);
      this.setState({
        user,
        listings: listings.result,
        team: team.result,
        availableKeywords: this.getAvailableKeywords(
          team.result.keywordsAvailability
        ),
        isModalOpen: false,
        isEditing: false,
        listingAction: '',
        selected: [],
      });
    }
  };

  handleOpenModal = () => {
    this.setState({ isModalOpen: true });
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false, isEditing: false, listingAction: '' });
  };

  sortData = sortKey => () => {
    const { listings, isAccending } = this.state;
    listings.sort((a, b) => {
      if (sortKey === 'address') {
        a = a[sortKey].line1;
        b = b[sortKey].line1;
      } else {
        a = a[sortKey];
        b = b[sortKey];
      }

      if (isAccending) {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        }
      } else {
        if (a < b) {
          return 1;
        } else if (a > b) {
          return -1;
        }
      }

      return 0;
    });
    this.setState({
      listings,
      isAccending: !isAccending,
    });
  };

  render() {
    const { classes } = this.props;
    const {
      selected,
      isEditing,
      user,
      listings,
      isAccending,
      isLoading,
      availableKeywords,
    } = this.state;

    return (
      <div>
        <h2>Listings</h2>
        <Divider />
        {isLoading ? (
          <h4>Loading...</h4>
        ) : (
          <div>
            <h4>
              Your AgentBuzz phone number: {user.localPhoneNumber}. Available
              Listing Keywords:{' '}
              {availableKeywords.length
                ? availableKeywords.join(', ')
                : 'No Keyword Available'}
            </h4>
            <div className={classes.actionsDiv}>
              <Button
                disabled={availableKeywords.length ? false : true}
                className={classes.btn}
                color="primary"
                onClick={this.handleOpenModal}
                variant="contained"
              >
                Create Listing
              </Button>

              <Modal
                aria-labelledby="create new listing"
                aria-describedby="create a new listing"
                open={this.state.isModalOpen}
                onClose={this.handleModalClose}
                disableBackdropClick={true}
                className={classes.modal}
              >
                <NewListingWizard
                  handleCloseModal={this.handleCloseModal}
                  handleUpdateListing={this.handleUpdateListing}
                  handleDeleteListing={this.handleDeleteListing}
                  handleCreateListing={this.handleCreateListing}
                  isEditing={isEditing}
                  listingId={selected[0] ? selected[0].id : null}
                  listings={listings}
                  availableKeywords={availableKeywords}
                  agent={user}
                />
              </Modal>
              <form className={classes.formRoot} autoComplete="off">
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="listing-action-selection">
                    Actions
                  </InputLabel>
                  <Select
                    value={this.state.listingAction}
                    onChange={this.handleChangeActionSelection}
                    inputProps={{
                      name: 'action',
                      id: 'listing-action',
                    }}
                  >
                    <MenuItem
                      disabled={selected.length === 1 ? false : true}
                      value="Edit"
                    >
                      Edit
                    </MenuItem>
                  </Select>
                </FormControl>
              </form>
            </div>
          </div>
        )}
        <Paper className={classes.root}>
          <div className={classes.tableWrapper}>
            {listings.length > 0 ? (
              <Table className={classes.table} aria-labelledby="tableTitle">
                <ListingsHead
                  numSelected={selected.length}
                  onSelectAllClick={this.handleSelectAllClick}
                  rowCount={listings.length}
                  sortData={this.sortData}
                  isAccending={isAccending}
                  classes={classes}
                />
                <TableBody>
                  {listings.map(listing => {
                    const isSelected = this.isSelected(listing);
                    return (
                      <TableRow
                        hover
                        onClick={event => this.handleClick(event, listing)}
                        role="radio"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={listing.listingId}
                        selected={isSelected}
                      >
                        <TableCell padding="checkbox">
                          <Radio checked={isSelected} />
                        </TableCell>
                        <TableCell component="th" scope="row" padding="default">
                          {listing.smsKeyword}
                        </TableCell>
                        <TableCell padding="default">
                          {listing.agentName || ''}
                        </TableCell>
                        <TableCell padding="default">
                          {listing.address.line1}
                        </TableCell>
                        <TableCell numeric>{listing.leadCount}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : isLoading ? (
              <span />
            ) : (
              <NoContent
                message={'You have no listings!'}
                showButton={true}
                clickHandler={this.handleOpenModal}
                btnText={'Create Listing'}
              />
            )}
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(Listings);



// WEBPACK FOOTER //
// ./src/components/Listings.js